import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Alert, Table, CustomInput, Collapse } from "reactstrap";
import { useApolloClient } from "@apollo/react-hooks";
import API from "../../../api/API";
import { GET_WORKFLOW } from "../../../api/projects";
import Loading from "../../atoms/loading";
import T from "../../atoms/translate";
import { t } from "../../../utils/utils";
import deploy_success from "../../../assets/images/deploy_success.svg";
import deploy_failed from "../../../assets/images/deploy_failed.svg";

const ProjectDeployment = ({
  project,
  workflowsToDeploy,
  setWorkflowsToDeploy,
  deployStatus,
}) => {
  const client = useApolloClient();
  const [loading, setLoading] = useState(true);
  const [workflows, setWorkflows] = useState([]);
  const fetchData = useCallback(async () => {
    if (project && project.workflows && Array.isArray(project.workflows)) {
      try {
        let selectableWorkflows = [];
        for (let i = 0; i < project.workflows.length; i++) {
          const workflow = project.workflows[i];
          if (workflow) {
            const res = await API.query(client, GET_WORKFLOW, {
              id: workflow.id,
            });
            if (res && res.data && res.data.getWorkflow) {
              const { content, master_content } = res.data.getWorkflow;
              if (content !== master_content) {
                selectableWorkflows.push(res.data.getWorkflow);
              }
            }
          }
        }
        setWorkflows(selectableWorkflows);
      } catch (error) {
        console.log(error);
      }
    }
    setLoading(false);
  }, [project, client]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <Row>
      <Col xs="12">
        <Alert color="info" className="propertybar-description">
          <h1>
            <T i18nKey="queEsDesplegar" />
          </h1>
          <p>
            <T i18nKey="queEsDesplegarSignificado" />
          </p>
        </Alert>
      </Col>
      <Col xs="12">
        <Collapse
          isOpen={
            !loading &&
            !deployStatus.deploying &&
            !deployStatus.ready &&
            !deployStatus.error
          }
        >
          <Alert color="info">
            <p className="mb-1 ss-fw-500 font-size-09">
              <T i18nKey="seleccionaWorkflowsADesplegar" />
            </p>
          </Alert>
          <Table responsive bordered>
            <thead>
              <tr>
                <th className="w-50">Workflow</th>
                <th className="w-50">
                  <T i18nKey="estado" />
                </th>
              </tr>
            </thead>
            <tbody>
              {workflows.map((workflow) => (
                <tr key={`workflow-${workflow.id}`}>
                  <td>{workflow.slug}</td>
                  <td>
                    <CustomInput
                      type="switch"
                      id={`switch-${workflow.id}`}
                      name="customSwitch"
                      label={
                        workflowsToDeploy.some((w) => w === workflow.id)
                          ? t("incluido")
                          : t("noIncluido")
                      }
                      checked={workflowsToDeploy.some((w) => w === workflow.id)}
                      value={workflow.id}
                      onChange={(event) => {
                        if (event.target && event.target.checked) {
                          setWorkflowsToDeploy([
                            ...workflowsToDeploy,
                            workflow.id,
                          ]);
                        } else {
                          setWorkflowsToDeploy(
                            workflowsToDeploy.filter((w) => w !== workflow.id)
                          );
                        }
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Alert color="info" className="propertybar-description">
            <b>
              <T i18nKey="infoModeloDespliegue" />
            </b>
          </Alert>
        </Collapse>
      </Col>
      <Col xs="auto" className="mx-auto">
        <Collapse isOpen={loading}>
          <Loading width={250} height={250} />
        </Collapse>
        <Collapse isOpen={deployStatus.deploying}>
          <Loading width={300} height={300} animation={5} />
          <h1 className="font-size-12 mb-4 mt-3 text-center">
            {deployStatus.status}
          </h1>
        </Collapse>
      </Col>
      <Col xs="12" className="my-3">
        <Collapse
          isOpen={deployStatus.ready || deployStatus.error}
          className="text-center"
        >
          <img
            src={deployStatus.ready ? deploy_success : deploy_failed}
            alt="success"
            width="40%"
            className="text-center"
          />
          <h1 className="font-size-12 mb-4 mt-3 text-center">
            {deployStatus.status}
          </h1>
        </Collapse>
      </Col>
    </Row>
  );
};

export default ProjectDeployment;
